import type { ErrorPageContentProps } from '../ErrorPageContent/ErrorPageContent';
import { ErrorPageContent } from '../ErrorPageContent/ErrorPageContent';

export const FullPageContent = (props: Exclude<ErrorPageContentProps, 'errorCode'>) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ErrorPageContent {...props} />;
};
